import axios from '../client';

export const createReservation = async (data) => {
	const adapterResponse = (data) => {
		if (!data.newReservation) return { created: false };
		let reservationId = data.newReservation.reservation_id;
		return { created: true, reservationId };
	};
	try {
		const reservation = await axios
			.put(`/api/v1/user/create-reservation`, data)
			.then((res) => adapterResponse(res.data))
			.catch((err) => ({ created: false, message: err.message }));

		return reservation;
	} catch (e) {
		return e;
	}
};
